import { Text, VStack } from '@chakra-ui/react';
import SecondaryButton from '@/components/common/buttons/SecondaryButton';
import PrimaryButton from '@/components/common/buttons/PrimaryButton';
import { useNavigate } from '@tanstack/react-router';
import { Routes } from '@/routes';
import { CONTROL_SURFACE_SHADOW } from '@/components/ui/shadows.ts';
import { AuthLayout } from '@/components/authentication/ui/AuthLayout';

function PaymentCancelPage() {
	const navigate = useNavigate();

	const handleReturnToProperties = () => {
		navigate({ to: Routes.PROPERTIES });
	};

	const handleTryAgain = () => {
		return navigate({ to: Routes.HOUSE_SETUP_NEW });
	};

	return (
		<AuthLayout title="Payment cancelled" hideLegalLinks>
			<VStack gap={6} textAlign="center" w="full">
				<Text fontSize="lg" color="fg.muted">
					Your payment was cancelled. You can try again or return to My Bundles.
				</Text>
				<VStack gap={3} w="full">
					<PrimaryButton
						py={2}
						onClick={handleTryAgain}
						size="lg"
						w="full"
						bg="brand.solid"
						color="brand.contrast"
						_hover={{ bg: 'brand.solidHover', color: 'brand.contrast' }}
					>
						Try again
					</PrimaryButton>
					<SecondaryButton
						variant="outline"
						onClick={handleReturnToProperties}
						w="full"
						bg="surface.default"
						color="brand.fg"
						borderColor="border.default"
						boxShadow={CONTROL_SURFACE_SHADOW}
					>
						Return to My Bundles
					</SecondaryButton>
				</VStack>
			</VStack>
		</AuthLayout>
	);
}

export const Route = createFileRoute({
	component: PaymentCancelPage,
});
